import React, { useState, useEffect } from "react";
import { motion, useScroll, useTransform, AnimatePresence } from "framer-motion";
import ProductShowcase from "./ProductShowcase";
import { Helmet } from "react-helmet";

const GalleryPage = () => {
  const [selectedFormat, setSelectedFormat] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const { scrollYProgress } = useScroll();
  
  const backgroundY = useTransform(scrollYProgress, [0, 1], ['0%', '100%']);
  const headerScale = useTransform(scrollYProgress, [0, 0.3], [1, 0.8]);
  const headerOpacity = useTransform(scrollYProgress, [0, 0.3], [1, 0.6]);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  // const formats = [
  //   {
  //     id: 'fluid-skin',
  //     name: 'Fluid Skin',
  //     image: '/assets/flu.png',
  //     description: 'Transforms the site’s background into your canvas while preserving content readability.',
  //     color: 'from-purple-500 to-pink-500'
  //   },
  //   {
  //     id: 'topscroll',
  //     name: 'Top Scroll',
  //     image: '/assets/top.png',
  //     description: ' Ad appears at the top of the page, staying visible as users begin scrolling.',
  //     color: 'from-blue-500 to-cyan-500'
  //   },
  //   {
  //     id: 'midscroll',
  //     name: 'Mid Scroll',
  //     image: '/assets/mid.png',
  //     description: ' Displays within the content flow as users scroll down the page.',
  //     color: 'from-green-500 to-teal-500'
  //   },
  //   {
  //     id: 'fullpage-overlay',
  //     name: 'Fullpage Overlay',
  //     image: '/assets/full.png',
  //     description: ' An immersive, full-screen ad that covers the entire page on load or interaction.',
  //     color: 'from-orange-500 to-red-500'
  //   },
  //   {
  //     id: 'floating',
  //     name: 'Floating',
  //     image: '/assets/flo.png',
  //     description: ' A movable ad unit that hovers over content while users browse.',
  //     color: 'from-indigo-500 to-purple-500'
  //   },
  //   {
  //     id: 'standard-display',
  //     name: 'Standard Display',
  //     image: '/assets/stn.png',
  //     description: ' Classic banner ad placements within content or sidebar.',
  //     color: 'from-gray-600 to-gray-800'
  //   }
  // ];
  const formats = [
    {
      id: 'fluid-skin',
      name: 'Fluid Skin',
      image: '/assets/flu.png',
      description: 'Transforms the site\'s background into your canvas while preserving content readability.',
      color: 'from-purple-500 to-pink-500',
      whatItIs: 'Transforms the site\'s background into your canvas while preserving content readability.',
      features: [
        'Full-page background branding',
        'Clickable areas for higher engagement',
        'Works well for brand takeovers and product launches'
      ]
    },
    {
      id: 'topscroll',
      name: 'Top Scroll',
      image: '/assets/top.png',
      description: 'Ad appears at the top of the page, staying visible as users begin scrolling.',
      color: 'from-blue-500 to-cyan-500',
      whatItIs: 'Ad appears at the top of the page, staying visible as users begin scrolling.',
      features: [
        'Prime header placement',
        'High visibility without interrupting content',
        'Ideal for awareness campaigns'
      ]
    },
    {
      id: 'midscroll',
      name: 'Mid Scroll',
      image: '/assets/mid.png',
      description: 'Displays within the content flow as users scroll down the page.',
      color: 'from-green-500 to-teal-500',
      whatItIs: 'Displays within the content flow as users scroll down the page.',
      features: [
        'Native feel, blends with content',
        'High viewability with contextual relevance',
        'Great for mid-funnel messaging'
      ]
    },
    {
      id: 'fullpage-overlay',
      name: 'Fullpage Overlay',
      image: '/assets/full.png',
      description: 'An immersive, full-screen ad that covers the entire page on load or interaction.',
      color: 'from-orange-500 to-red-500',
      whatItIs: 'An immersive, full-screen ad that covers the entire page on load or interaction.',
      features: [
        'Maximum visual impact',
        'Interactive and rich media options',
        'Best for high-impact product reveals'
      ]
    },
    {
      id: 'floating',
      name: 'Floating',
      image: '/assets/flo.png',
      description: 'A movable ad unit that hovers over content while users browse.',
      color: 'from-indigo-500 to-purple-500',
      whatItIs: 'A movable ad unit that hovers over content while users browse.',
      features: [
        'Persistent visibility',
        'User-controlled positioning',
        'Good for retargeting and CTAs without intrusiveness'
      ]
    },
    {
      id: 'native-advertisement',
      name: 'Native Advertisement',
      image: '/assets/stn.png',
      description: ' Ad formats that match the look, feel, and function of the media platform they appear on..',
      color: 'from-purple-500 to-pink-500',
      whatItIs: 'Ad formats that match the look, feel, and function of the media platform they appear on.',
      features: [
        'Blends seamlessly with editorial content',
        'Higher user engagement and lower ad fatigue',
        'Supports sponsored articles, in-feed ads, and recommendation widgets'
      ]
    },
    {
      id: 'ctv-advertising',
      name: 'CTV Advertising',
      image: '/assets/tv.png',
      description: 'Delivers high-impact videos on Connected TVs, combining reach with digital targeting.',
      color: 'from-orange-500 to-red-500',
      whatItIs: 'Delivers high-impact videos on Connected TVs, combining reach with digital targeting.',
      features: [
        'Full-screen, non-skippable formats',
        'High viewability and completion rates',
        'Targeting by audience, location, or device',
        'Supports interactive and QR-enabled experiences',
      ]
    },
    {
      id: 'push-notification',
      name: 'Push Notification',
      image: '/assets/pushicon.png',
      description: 'Clickable messages sent directly to users devices or browsers, even when they’re not actively browsing.',
      color: 'from-indigo-500 to-purple-500',
      whatItIs: 'Clickable messages sent directly to users devices or browsers, even when they’re not actively browsing.',
      features: [
        'Real-time delivery with high visibility',
        'Works across mobile and desktop',
        'Boosts engagement through timely, personalized messages',
      
      ]
    }
  ];
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.8,
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 60, scale: 0.9 },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        type: "spring",
        stiffness: 80,
        damping: 20,
        duration: 0.8
      }
    }
  };

  const cardHoverVariants = {
    initial: { scale: 1, rotateY: 0 },
    hover: {
      scale: 1.05,
      rotateY: 5,
      transition: {
        type: "spring",
        stiffness: 300,
        damping: 20
      }
    }
  };

  const floatingAnimation = {
    y: [-10, 10, -10],
    transition: {
      duration: 3,
      repeat: Infinity,
      ease: "easeInOut"
    }
  };

  return (
    <>
    <Helmet>
       <title>
       Bidbox Ad Gallery | Showcase Targeted Campaign Creativity
        </title>
        <meta
          name="description"
          content="Explore Bidbox’s Ad Gallery – see powerful, targeted ad campaigns in action. Get inspired & elevate your advertising with DSP strategy insights."
        />
        {/* <meta
          name="keywords"
          content="BidBox AI, Demand-Side Platform, DSP solutions, targeted advertising, ad campaign optimization, programmatic advertising, real-time bidding, ad tech, audience segmentation, AI-driven advertising, digital marketing, performance marketing, cross-channel advertising, ad exchange, ad placement, ad inventory, ad network, data-driven marketing, media buying."
        /> */}
         <link
          rel="canonical"
          href="https://bidbox.ai/ad-gallery"
        />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
    </Helmet>
    <div className="min-h-screen relative overflow-hidden mt-14">
      {/* Animated Background */}
      <motion.div 
        style={{ y: backgroundY }}
        className="absolute inset-0 bg-gradient-to-br from-purple-50 via-blue-50 via-pink-50 to-indigo-100"
      />
      
      {/* Floating Geometric Shapes */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <motion.div 
          animate={floatingAnimation}
          className="absolute top-20 left-10 w-20 h-20 bg-gradient-to-r from-purple-400 to-pink-400 rounded-full opacity-20 blur-xl"
        />
        <motion.div 
          animate={{ ...floatingAnimation, transition: { ...floatingAnimation.transition, delay: 1 } }}
          className="absolute top-40 right-20 w-32 h-32 bg-gradient-to-r from-blue-400 to-cyan-400 rounded-full opacity-15 blur-2xl"
        />
        <motion.div 
          animate={{ ...floatingAnimation, transition: { ...floatingAnimation.transition, delay: 2 } }}
          className="absolute bottom-40 left-1/4 w-24 h-24 bg-gradient-to-r from-green-400 to-teal-400 rounded-full opacity-20 blur-xl"
        />
      </div>

      <div className="relative z-10 p-4 md:p-8 pt-20">
        <div className="max-w-7xl mx-auto">
          {/* Header Section */}
          <motion.div 
            style={{ scale: headerScale, opacity: headerOpacity }}
            className="text-center mb-16 md:mb-24"
          >
            <motion.div
              initial={{ opacity: 0, y: -50 }}
              animate={{ opacity: isVisible ? 1 : 0, y: isVisible ? 0 : -50 }}
              transition={{ duration: 1, delay: 0.2 }}
            >
              <h1 className="text-5xl md:text-8xl lg:text-9xl font-black mb-6 leading-none">
                <motion.span 
                  className="inline-block bg-gradient-to-r from-purple-600 via-pink-600 to-blue-600 bg-clip-text text-transparent"
                  animate={{
                    backgroundPosition: ['0% 50%', '100% 50%', '0% 50%'],
                  }}
                  transition={{
                    duration: 5,
                    repeat: Infinity,
                    ease: "linear"
                  }}
                  style={{
                    backgroundSize: '200% 200%'
                  }}
                >
                  Ad
                </motion.span>{' '}
                <motion.span 
                  className="inline-block text-gray-800"
                  initial={{ rotateX: -90 }}
                  animate={{ rotateX: 0 }}
                  transition={{ duration: 0.8, delay: 0.5 }}
                >
                  Gallery
                </motion.span>
              </h1>
            </motion.div>
            
            <motion.p
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: isVisible ? 1 : 0, y: isVisible ? 0 : 30 }}
              transition={{ duration: 0.8, delay: 0.6 }}
              className="text-lg md:text-2xl text-gray-600 max-w-5xl mx-auto leading-relaxed font-light"
            >
              Where creativity meets impact! Explore our high-performing rich media 
              and impactful ad formats designed to{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-blue-600 font-medium">
                grab attention
              </span>, trigger engagement, and leave lasting impressions.
            </motion.p>
          </motion.div>

          {/* Format Selection Section */}
            {/* <motion.div
              variants={containerVariants}
              initial="hidden"
              animate="visible"
              className="mb-20"
            >
              <motion.h2 
                variants={itemVariants}
                className="text-3xl md:text-5xl font-bold text-gray-800 mb-12 text-center"
              >
                Choose Your{' '}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-purple-600">
                  Format
                </span>
              </motion.h2>
              
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-6 md:gap-8">
                {formats.map((format, index) => (
                  <motion.div
                    key={format.id}
                    variants={itemVariants}
                    whileHover="hover"
                    initial="initial"
                    className="group cursor-pointer"
                    onClick={() => setSelectedFormat(format)}
                  >
                 <motion.div
  variants={cardHoverVariants}
  className="relative p-6 md:p-8 rounded-3xl bg-white/80 backdrop-blur-sm border border-white/50 shadow-lg hover:shadow-2xl transition-all duration-500 min-h-[250px] min-w-[150px] flex flex-col justify-center"
  style={{
    background: `linear-gradient(135deg, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0.7) 100%)`
  }}
>
                     
                      <div className={`absolute inset-0 rounded-3xl bg-gradient-to-r ${format.color} opacity-0 group-hover:opacity-10 transition-opacity duration-300`} />
                      
                      <div className="relative flex flex-col items-center text-center space-y-4">
                        <motion.div 
                          className="relative"
                          whileHover={{ scale: 1.1, rotate: 5 }}
                          transition={{ type: "spring", stiffness: 300, damping: 20 }}
                        >
                          <div className={`absolute -inset-2 bg-gradient-to-r ${format.color} rounded-2xl opacity-20 blur-sm group-hover:opacity-40 transition-opacity duration-300`} />
                          <img 
                            src={format.image} 
                            alt={format.name}
                            className="relative w-16 h-16 md:w-20 md:h-20 rounded-2xl object-cover shadow-lg"
                          />
                        </motion.div>
                        
                        <div>
                          <h3 className="font-bold text-sm md:text-base text-gray-800 mb-1">
                            {format.name}
                          </h3>
                          <p className="text-xs md:text-sm text-gray-500 font-medium">
                            {format.description}
                          </p>
                        </div>
                      </div>
                    </motion.div>
                  </motion.div>
                ))}
              </div>
            </motion.div> */}
<div className="  p-4 md:p-8">
      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        className="mb-2"
      >
        <motion.h2 
          variants={itemVariants}
          className="text-3xl md:text-5xl font-bold text-gray-800 mb-2 text-center"
        >
          Know Your{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-purple-600">
            Format
          </span>
        </motion.h2>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 md:gap-8 mt-10 mb-10">
          {formats.map((format, index) => (
            <motion.div
              key={format.id}
              variants={itemVariants}
              whileHover="hover"
              initial="initial"
              className="group cursor-pointer"
              onClick={() => setSelectedFormat(format)}
            >
              <motion.div
                variants={cardHoverVariants}
                className="relative p-2 md:p-2 rounded-3xl bg-white/80 backdrop-blur-sm border border-white/50 shadow-lg hover:shadow-2xl transition-all duration-500 min-h-[250px] min-w-[150px] flex flex-col justify-center"
                style={{
                  background: `linear-gradient(135deg, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0.7) 100%)`
                }}
              >
                <div className={`absolute inset-0 rounded-3xl bg-gradient-to-r ${format.color} opacity-0 group-hover:opacity-10 transition-opacity duration-300`} />
                
                <div className="relative flex flex-col items-center text-center space-y-4">
                  <motion.div 
                    className="relative"
                    whileHover={{ scale: 1.1, rotate: 5 }}
                    transition={{ type: "spring", stiffness: 300, damping: 20 }}
                  >
                    <div className={`absolute -inset-2 bg-gradient-to-r ${format.color} rounded-2xl opacity-20 blur-sm group-hover:opacity-40 transition-opacity duration-300`} />
                    <img 
                            src={format.image} 
                            alt={format.name}
                            className="relative w-16 h-16 md:w-20 md:h-20 rounded-2xl object-cover shadow-lg"
                          />
                    
                  </motion.div>
                  
                  <div>
                    <h3 className="font-bold text-sm md:text-base text-gray-800 mb-1">
                      {format.name}
                    </h3>
                    <p className="text-xs md:text-sm text-gray-500 font-medium">
                      {format.description}
                    </p>
                  </div>
                </div>
              </motion.div>
            </motion.div>
          ))}
        </div>
      </motion.div>

  
      <AnimatePresence>
        {selectedFormat && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4"
            onClick={() => setSelectedFormat(null)}
          >
            <motion.div
              initial={{ scale: 0.8, opacity: 0, y: 50 }}
              animate={{ scale: 1, opacity: 1, y: 0 }}
              exit={{ scale: 0.8, opacity: 0, y: 50 }}
              transition={{ type: "spring", stiffness: 300, damping: 30 }}
              className="bg-white rounded-3xl p-8 max-w-lg w-full shadow-2xl max-h-[90vh] overflow-y-auto"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="space-y-2">
           
                <div className="text-center">
                  <div className="relative inline-block mb-2">
                    <div className={`absolute -inset-3 bg-gradient-to-r ${selectedFormat.color} rounded-2xl opacity-20 blur-sm`} />
                    <img 
                            src={selectedFormat.image} 
                            alt={selectedFormat.name}
                            className="relative w-16 h-16 md:w-20 md:h-20 rounded-2xl object-cover shadow-lg"
                          />
                  </div>
                  <h3 className="text-3xl font-bold text-gray-800 mb-2">
                    {selectedFormat.name}
                  </h3>
                </div>

               
                <div className="space-y-2">
                  <h4 className="text-lg font-bold text-gray-800">What it is:</h4>
                  <p className="text-gray-600 leading-relaxed">
                    {selectedFormat.whatItIs}
                  </p>
                </div>

                  <div className="space-y-3">
                  <h4 className="text-lg font-bold text-gray-800">Features:</h4>
                  <div className="space-y-1">
                    {selectedFormat.features.map((feature, index) => (
                      <motion.div
                        key={index}
                        initial={{ opacity: 0, x: -20 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ delay: index * 0.1 }}
                        className="flex items-start space-x-3"
                      >
                        <div className={`w-2 h-2 rounded-full bg-gradient-to-r ${selectedFormat.color} mt-2 flex-shrink-0`} />
                        <p className="text-gray-600 leading-relaxed">{feature}</p>
                      </motion.div>
                    ))}
                  </div>
                </div>

              
                <div className="flex space-x-4 pt-4">
                  <button
                    onClick={() => setSelectedFormat(null)}
                    className="flex-1 px-6 py-3 bg-gray-100 text-gray-700 rounded-2xl font-semibold hover:bg-gray-200 transition-colors duration-300"
                  >
                    Close
                  </button>
               
                </div>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
         
          <motion.div
            initial={{ opacity: 0, y: 100 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 1 }}
            className="relative"
          >
            <div className="bg-white/60 backdrop-blur-lg rounded-[2rem] md:rounded-[3rem] p-8 md:p-16 border border-white/30 shadow-2xl overflow-hidden">
            
              <div className="absolute inset-0 opacity-5">
                <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(120,119,198,0.3),transparent)]" />
              </div>
              
              <div className="relative">
                <div className="text-center mb-16">
                  <motion.h3 
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8 }}
                    className="text-3xl md:text-5xl font-black text-gray-800 mb-6"
                  >
                    Unlock the Power of{' '}
                    <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-blue-600">
                    Rich Media Advertising
                    </span>
                  </motion.h3>
                  <motion.p 
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8, delay: 0.2 }}
                    className="text-gray-600 text-lg md:text-xl max-w-4xl mx-auto leading-relaxed"
                  >
                    Deliver ads that don’t just show, but engage. Our formats are designed to drive interaction, boost recall, and turn views into actions.

                  </motion.p>
                </div>
                
                <div className="grid md:grid-cols-3 gap-8 md:gap-12">
                  {[
                    {
                      title: "Interactive Experiences",
                      description: "Drive deeper engagement through tap, swipe, expand, or scroll.",
                      icon: "🕹️",
                      gradient: "from-yellow-400 to-orange-500"
                    },
                    {
                      title: "Visual Storytelling",
                      description: "Blend motion, design, and interactivity into one immersive format.",
                      icon: "🎬",
                      gradient: "from-pink-400 to-purple-500"
                    },
                    {
                      title: "High Performance Delivery",
                      description: "Optimized to perform across devices with advanced tracking.",
                      icon: "🚀",
                      gradient: "from-blue-400 to-indigo-500"
                    }
                  ].map((feature, index) => (
                    <motion.div
                      key={feature.title}
                      initial={{ opacity: 0, y: 50 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                      transition={{ duration: 0.8, delay: index * 0.2 }}
                      whileHover={{ y: -10, scale: 1.02 }}
                      className="text-center group"
                    >
                      <motion.div 
                        className={`w-20 h-20 bg-gradient-to-r ${feature.gradient} rounded-3xl flex items-center justify-center mx-auto mb-6 shadow-lg group-hover:shadow-xl transition-shadow duration-300`}
                        whileHover={{ rotate: 360 }}
                        transition={{ duration: 0.8 }}
                      >
                        <span className="text-3xl">{feature.icon}</span>
                      </motion.div>
                      <h4 className="font-bold text-xl text-gray-800 mb-3">
                        {feature.title}
                      </h4>
                      <p className="text-gray-600 leading-relaxed">
                        {feature.description}
                      </p>
                    </motion.div>
                  ))}
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Format Modal */}
      {/* <AnimatePresence>
        {selectedFormat && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4"
            onClick={() => setSelectedFormat(null)}
          >
            <motion.div
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              transition={{ type: "spring", stiffness: 300, damping: 30 }}
              className="bg-white rounded-3xl p-8 max-w-md w-full shadow-2xl"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="text-center">
                <img 
                  src={selectedFormat.image} 
                  alt={selectedFormat.name}
                  className="w-24 h-24 rounded-2xl mx-auto mb-4 shadow-lg"
                />
                <h3 className="text-2xl font-bold text-gray-800 mb-2">
                  {selectedFormat.name}
                </h3>
                <p className="text-gray-600 mb-6">
                  {selectedFormat.description}
                </p>
                <button
                  onClick={() => setSelectedFormat(null)}
                  className="px-6 py-3 bg-gradient-to-r from-purple-600 to-blue-600 text-white rounded-full font-semibold hover:shadow-lg transition-shadow duration-300"
                >
                  Close
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence> */}
    </div>
    <ProductShowcase/>
    </>
  );
};

export default GalleryPage;



// import React from "react";
// import { motion } from "framer-motion";
// import ProductShowcase from "./ProductShowcase";
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Autoplay } from 'swiper/modules';
// import 'swiper/css';
// const GalleryPage = () => {
//      // Animation variants
//   const fadeInVariant = {
//     hidden: { opacity: 0, y: 50 },
//     visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
//   };

//   const staggerContainer = {
//     hidden: { opacity: 0 },
//     visible: {
//       opacity: 1,
//       transition: {
//         staggerChildren: 0.1,
//       },
//     },
//   };

//   const staggerItem = {
//     hidden: { opacity: 0, y: 20 },
//     visible: {
//       opacity: 1,
//       y: 0,
//       transition: {
//         type: "spring",
//         stiffness: 100,
//       },
//     },
//   };

//   const scaleUp = {
//     initial: { scale: 1 },
//     hover: {
//       scale: 1.05,
//       transition: { duration: 0.3 },
//     },
//   };

//   const fadeInUpVariant = {
//     hidden: { opacity: 0, y: 30 },
//     visible: {
//       opacity: 1,
//       y: 0,
//       transition: {
//         duration: 0.6,
//         ease: "easeOut",
//       },
//     },
//   };
//   const fadeIn = {
//     hidden: { opacity: 0, y: 20 },
//     visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
//   };

//   const formats = [
//     {
//       id: 'fluid-skin',
//       name: 'Fluid skin',
//       image: '/assets/flu.png'
//     },
//     {
//       id: 'topscroll',
//       name: 'Top scroll',
//       image: '/assets/top.png'
//     },
//     {
//       id: 'midscroll',
//       name: 'Mid scroll',
//       image: '/assets/mid.png'
//     },
//     {
//       id: 'fullpage-overlay',
//       name: 'Fullpage overlay',
//       image: '/assets/full.png'
//     },
//     {
//       id: 'floating',
//       name: 'Floating',
//       image: '/assets/flo.png'
//     },
//     {
//       id: 'standard-display',
//       name: 'Standard display',
//       image: '/assets/stn.png'
//     }
    
//   ];
//   return (
//     <>
//     {/* <div className="flex min-h-[100dvh] justify-center items-center dark:bg-slate-800 overflow-x-hidden">
//           <motion.div
//             initial={{ opacity: 0, scale: 0.8 }}
//             animate={{ opacity: 1, scale: 1 }}
//             transition={{ duration: 0.8, type: "spring", stiffness: 50 }}
//             className="mx-auto flex h-full min-h-[100dvh] w-full items-center justify-center px-4 sm:px-6 lg:px-8"
//           >
//             <div className="text-center max-w-4xl">
//               <motion.h1
//                 initial={{ opacity: 0, y: -20 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ delay: 0.3, duration: 0.5 }}
//                 className="text-4xl font-extrabold tracking-tight text-gray-900 dark:text-slate-200 sm:text-5xl md:text-6xl"
//                 style={{
//                   WebkitTransform: "translateY(0px)",
//                   transform: "translateY(0px)",
//                 }}
//               >
//                 <span className="block xl:inline">
//                   <span className="mb-1 block">Ad gallery</span>
//                   <motion.span
//                     initial={{ backgroundPosition: "0%" }}
//                     animate={{ backgroundPosition: "100%" }}
//                     transition={{
//                       repeat: Infinity,
//                       duration: 3,
//                       ease: "linear",
//                       repeatType: "reverse",
//                     }}
//                     className="bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent"
//                   >
//                     Redefined for Impact
//                   </motion.span>
//                   <p className="mb-1 block">
//                     10X Efficiency
//                     <span className="bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent">
//                       with Bidbox.Ai
//                     </span>{" "}
//                   </p>
//                 </span>
//               </motion.h1>
  
//               <motion.p
//                 initial={{ opacity: 0 }}
//                 animate={{ opacity: 1 }}
//                 transition={{ delay: 0.6, duration: 0.5 }}
//                 className="mx-auto mt-3 max-w-xl text-lg text-gray-500 dark:text-slate-400 sm:mt-5 md:mt-5"
//               >
//               Where creativity meets impact! Explore some of our high-performing rich media and high impact ad formats designed to grab attention, trigger engagement, and leave a lasting impression.
//               </motion.p>
  
//               <motion.div
//                 initial={{ opacity: 0, y: 20 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ delay: 0.8, duration: 0.5 }}
//                 className="mt-5 sm:mt-8 sm:flex sm:justify-center"
//               >
               
//               </motion.div>
//             </div>
//           </motion.div>
//         </div> */}
//          <div className="min-h-screen bg-gradient-to-br from-purple-50 via-blue-50 to-indigo-100 p-4 md:p-8 mt-14">
//       <div className="max-w-6xl mx-auto">
//         {/* Header */}
//         <div className="text-center mb-12">
//           <h1 className="text-4xl md:text-7xl font-bold mb-6">
//             <span className="bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent">
//               Ad
//             </span>{' '}
//             <span className="text-gray-800">gallery</span>
//           </h1>
//           <p className="text-lg md:text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
//             Where creativity meets impact! Explore some of our high-performing rich media and high impact ad formats 
//             designed to grab attention, trigger engagement, and leave a lasting impression.
//           </p>
//         </div>

//         {/* Format Display Section */}
//         {/* <div className="mb-16">
//           <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 mb-8 text-center">
//             Select a format
//           </h2>
          
         
//           <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6 md:gap-8">
//             {formats.map((format) => (
//               <div
//                 key={format.id}
//                 className="group p-6 rounded-2xl bg-white border border-gray-200 shadow-sm hover:shadow-md transition-all duration-300"
//               >
//                 <div className="flex flex-col items-center text-center space-y-4">
//                   <div className="transform group-hover:scale-105 transition-transform duration-200">
//                     <img 
//                       src={format.image} 
//                       alt={format.name}
//                       className="w-16 h-16 rounded-lg object-cover shadow-sm"
//                     />
//                   </div>
//                   <h3 className="font-medium text-sm md:text-base text-gray-700 leading-tight">
//                     {format.name}
//                   </h3>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div> */}
//  <div className="mb-16">
//       <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 mb-8 text-center">
//         Select a format
//       </h2>

//       <Swiper
//         modules={[Autoplay]}
//         spaceBetween={20}
//         slidesPerView={2}
//         autoplay={{ delay: 3000, disableOnInteraction: false }}
//         breakpoints={{
//           640: { slidesPerView: 3 },
//           1024: { slidesPerView: 6 }
//         }}
//         loop={true}
//       >
//         {formats.map((format) => (
//           <SwiperSlide key={format.id}>
//             <div className="group p-6 rounded-2xl bg-white border border-gray-200 shadow-sm hover:shadow-md transition-all duration-300">
//               <div className="flex flex-col items-center text-center space-y-4">
//                 <div className="transform group-hover:scale-105 transition-transform duration-200">
//                   <img
//                     src={format.image}
//                     alt={format.name}
//                     className="w-16 h-16 rounded-lg object-cover shadow-sm"
//                   />
//                 </div>
//                 <h3 className="font-medium text-sm md:text-base text-gray-700 leading-tight">
//                   {format.name}
//                 </h3>
//               </div>
//             </div>
//           </SwiperSlide>
//         ))}
//       </Swiper>
//     </div>
//         {/* Additional Info Section */}
//         <div className="bg-white/60 backdrop-blur-sm rounded-3xl p-8 md:p-12 border border-white/20 shadow-lg">
//           <div className="text-center">
//             <h3 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
//               Premium Ad Formats
//             </h3>
//             <p className="text-gray-600 text-lg max-w-3xl mx-auto leading-relaxed">
//               Our comprehensive collection of ad formats ensures maximum engagement across all devices and platforms. 
//               Each format is optimized for performance, designed for impact, and built to deliver exceptional results 
//               for your advertising campaigns.
//             </p>
//           </div>
          
//           <div className="grid md:grid-cols-3 gap-8 mt-12">
//             <div className="text-center">
//               <div className="w-12 h-12 bg-gradient-to-r from-purple-500 to-blue-500 rounded-full flex items-center justify-center mx-auto mb-4">
//                 <div className="w-6 h-6 bg-white rounded-full"></div>
//               </div>
//               <h4 className="font-semibold text-gray-800 mb-2">High Performance</h4>
//               <p className="text-gray-600 text-sm">Optimized for maximum engagement and conversion rates</p>
//             </div>
            
//             <div className="text-center">
//               <div className="w-12 h-12 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full flex items-center justify-center mx-auto mb-4">
//                 <div className="w-6 h-6 bg-white rounded-full"></div>
//               </div>
//               <h4 className="font-semibold text-gray-800 mb-2">Rich Media</h4>
//               <p className="text-gray-600 text-sm">Interactive elements that captivate and engage audiences</p>
//             </div>
            
//             <div className="text-center">
//               <div className="w-12 h-12 bg-gradient-to-r from-purple-500 to-blue-500 rounded-full flex items-center justify-center mx-auto mb-4">
//                 <div className="w-6 h-6 bg-white rounded-full"></div>
//               </div>
//               <h4 className="font-semibold text-gray-800 mb-2">Cross Platform</h4>
//               <p className="text-gray-600 text-sm">Seamless experience across desktop, mobile, and tablet</p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
    
//         <ProductShowcase />
//         </>
//   );
// };

// export default GalleryPage;
